import React, { Component } from 'react';
import {
  Button, Card, CardBody, Col, Table, UncontrolledTooltip, Alert,
} from 'reactstrap';
import { Link, Redirect } from 'react-router-dom';
import Moment from 'moment';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import CalendarIcon from 'mdi-react/CalendarIcon';
import swal from 'sweetalert';

import ConfirmStockModal from '../../../Stocks/components/ConfirmStockModal';
import AddInventoryModal from '../../components/AddInventoryModal';
import AddTransactionModal from '../../components/AddTransactionModal';
import SubmitReportModal from './SubmitReportModal';
import CommissaryService from '../../../../services/CommissaryService';
import CommonService from '../../../../services/CommonService';
import global from '../../../../global';

class CommissaryDashboard extends Component {
  static propTypes = {
    itemID: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.userData = JSON.parse(localStorage.getItem('userData'));
    this.currDate = new Date();
    const { itemID } = this.props;
    const locationId = global.parseToNumber(this.userData.location_id) !== 0 && ((['1', '5', '6'].indexOf(this.userData.type) > -1) === true) ? this.userData.location_id : itemID;
    this.state = {
      CommInventory: [],
      commissaryData: {
        warehouseName: 'Inventory',
        receiving_report: '0',
        withdrawal_report: '0',
        stock_balance: '0',
        grand_total: '0',
        transfered_stock: '0',
      },
      formdata: {
        productName: '',
        batchCode: '',
        perKilo: '',
        unitCost: '',
        supplierName: '',
        added_by: this.userData.user_id,
        location_id: locationId,
        deliveryDate: this.currDate,
        deliveryDate_txt: Moment(this.currDate).format('YYYY-MM-DD HH:mm:ss'),
        inventoryDate: this.currDate,
        inventoryDate_txt: Moment(this.currDate).format('YYYY-MM-DD HH:mm:ss'),
      },
      stockStatus: '',
      title: 'Add',
      goTo: false,
      goToPage: '/',
    };
    this.isLoading = false;
    this.locationID = locationId;
    this.toggleModal = this.toggleModal.bind(this);
    this.addToggle = this.addToggle.bind(this);
    this.addTransaction = this.addTransaction.bind(this);
    this.addSubmitForm = this.addSubmitForm.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.executeModal = '';
    this.searchStocks = this.searchStocks.bind(this);
    this.noreports = false;
    this.reportdate = '';
  }

  componentDidMount() {
    this.isLoading = true;
    this.onLoadInventory();
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  onLoadInventory = async (invtDate = '') => {
    const { formdata } = this.state;
    try {
      const storageData = JSON.parse(localStorage.getItem('commissaryInventoryDate'));
      const deliveryDate = invtDate !== '' ? invtDate : storageData !== null && invtDate === '' ? storageData.date : Moment(new Date()).format('YYYY-MM-DD');
      localStorage.setItem('commissaryInventoryDate', JSON.stringify({ type: 'logistic', date: deliveryDate }));

      const response = await CommissaryService.getCommInventory(formdata.location_id, deliveryDate);
      if (this.isLoading && response) {
        this.noreports = response.noreports;
        this.reportdate = Moment(response.last_reportdate).format('MMMM DD, YYYY');
        this.setState({
          CommInventory: response.inventory,
          commissaryData: {
            name: response.location_name,
            total_beginning: response.total_beginning,
            total_receive: response.total_in,
            transfered_stock: response.transfered_stock,
            transfered_stock_total: response.transfered_stock_total,
            total_out: response.total_out,
            date: response.inventory_date,
          },
        });
      }
    } catch (err) {
      console.log('Error: ', err.message);
      this.isLoading = false;
    }
  }

  handleChange = (e, fieldName) => {
    if (fieldName === 'deliver') {
      if (e) {
        this.setState(prevState => ({
          formdata: { ...prevState.formdata, deliverVal: e.value, deliverTxt: e.label },
        }));
      } else {
        this.setState(prevState => ({
          formdata: { ...prevState.formdata, deliverVal: undefined, deliverTxt: undefined },
        }));
      }
    } else if (fieldName === 'product') {
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, product: e.value, productName: e.label },
      }));
    } else if (fieldName === 'supplier') {
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, supplier: e.value, supplierName: e.label },
      }));
    } else if (fieldName === 'number') {
      const { name, value } = e.target;
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, [name]: value.replace(/[^0-9.]/g, '') },
      }));
    } else if (fieldName === 'date') {
      const date = new Date(e);
      const dateText = Moment(date).format('YYYY-MM-DD HH:mm:ss');
      this.setState(prevState => ({
        formdata: {
          ...prevState.formdata, inventoryDate: date, inventoryDate_txt: dateText, deliveryDate: date, deliveryDate_txt: dateText,
        },
      }));
    } else if (fieldName === 'ddate') {
      const date = new Date(e);
      const dateText = Moment(date).format('YYYY-MM-DD HH:mm:ss');
      this.setState(prevState => ({
        formdata: {
          ...prevState.formdata, deliveryDate: date, deliveryDate_txt: dateText,
        },
      }));
    } else if (fieldName === 'idate') {
      const date = new Date(e);
      const dateText = Moment(date).format('YYYY-MM-DD HH:mm:ss');
      this.setState(prevState => ({
        formdata: {
          ...prevState.formdata, inventoryDate: date, inventoryDate_txt: dateText,
        },
      }));
    } else {
      const { name, value } = e.target;
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, [name]: value },
      }));
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({
      formdata: {
        productName: '',
        batchCode: '',
        perKilo: '',
        unitCost: '',
        supplierName: '',
        deliveryDate: '',
        deliveryDate_txt: '',
      },
    });
  };

  goTo = (ev) => {
    this.setState({ goTo: true, goToPage: ev.currentTarget.dataset.href });
  }

  goBack = () => {
    this.setState({ goTo: true, goToPage: '/inventory/logistic/list' });
  }

  searchStocks(e) {
    e.preventDefault();
    const { formdata } = this.state;
    const deliveryDate = Moment(formdata.deliveryDate).format('YYYY-MM-DD');
    this.onLoadInventory(deliveryDate);
  }

  addToggle() {
    this.executeModal = 'addinventory';
    this.setState(prevstate => (
      {
        formdata: {
          ...prevstate.formdata,
          productName: '',
          batchCode: '',
          referenceNumber: '',
          roomName: '',
          perKilo: '',
          unitCost: '',
          supplierName: '',
        },
        errorMsg: '',
      }
    ));
    this.toggleModal('Add');
    this.handleSubmit = (e) => { this.addSubmitForm(e); };
  }

  addTransaction() {
    this.executeModal = 'addtransaction';
    this.setState(prevstate => (
      {
        formdata: {
          ...prevstate.formdata,
          productName: '',
          batchCode: '',
          referenceNumber: '',
          roomName: '',
          perKilo: '',
          unitCost: '',
          supplierName: '',
        },
        errorMsg: '',
      }
    ));
    this.toggleModal('New');
    this.handleSubmit = (e) => { this.submitTransactionForm(e); };
  }

  async addSubmitForm(e) {
    e.preventDefault();
    const form = document.getElementById('insertInventory_form');
    const formdata = new FormData(form);
    formdata.append('location_id', this.locationID);
    formdata.append('added_by', this.userData.user_id);

    try {
      const result = await CommonService.insertData('addwarehouseinventory', formdata, false);
      if (result) {
        if (result.msg === true) {
          this.onLoadInventory();
          this.setState({ errorMsg: '', modal: false });

          swal({
            title: 'New Stock was added!',
            text: 'Would you like to add a new stock?',
            icon: 'success',
            closeOnClickOutside: false,
            buttons: {
              no: 'NOPE',
              yes: 'ADD NEW',
            },
          }).then((name) => {
            name = name.toLowerCase();

            if (name === 'yes') {
              this.addToggle();
            }
          });
        } else {
          this.setState({ errorMsg: result.msg });
        }
      } else {
        swal('', 'Failed to add inventory!', 'danger');
      }
    } catch (err) {
      console.log(err);
    }
    this.isLoading = true;
  }

  async submitTransactionForm(e) {
    e.preventDefault();
    const form = document.getElementById('insertTransaction_form');
    const formdata = new FormData(form);
    formdata.append('location_id', this.locationID);
    formdata.append('added_by', this.userData.user_id);

    try {
      const result = await CommonService.insertData('addtransactionform', formdata, false);
      if (result) {
        if (result.msg === true) {
          this.onLoadInventory();
          this.setState({ errorMsg: '', modal: false });

          swal({
            title: 'New Stock was added!',
            text: 'Would you like to add a new stock?',
            icon: 'success',
            closeOnClickOutside: false,
            buttons: {
              no: 'NOPE',
              yes: 'ADD NEW',
            },
          }).then((name) => {
            name = name.toLowerCase();

            if (name === 'yes') {
              this.addTransaction();
            }
          });
        } else {
          this.setState({ errorMsg: result.msg });
        }
      } else {
        swal('', 'Failed to add inventory!', 'danger');
      }
    } catch (err) {
      console.log(err);
    }
    this.isLoading = true;
  }

  reportToggle(e, stockItemId, stockBalance = 0) {
    e.preventDefault();
    e.stopPropagation();
    this.executeModal = 'submitreport';
    this.setState({
      formdata: {
        actualCount: stockBalance,
        note: '',
      },
    });
    this.toggleModal();
    this.handleSubmit = (ev) => { this.submitReport(ev, stockItemId); };
  }

  confirmStock(e, controlID, status, quantity = 0) {
    e.preventDefault();
    e.stopPropagation();
    this.executeModal = 'confirmation';
    this.toggleModal();
    this.setState({
       formdata: {
          actualQuantity: quantity,
          note: '',
          controlID,
          status,
          quantity,
       },
       stockStatus: status.toString(),
    });
    // submit form
    this.handleSubmit = (ev) => { this.submitConfirmation(ev); };
 }

 async submitConfirmation(e) {
    e.preventDefault();
    const { formdata } = this.state;
    formdata.locationId = this.locationID;

    if ((formdata.status === 1 && formdata.actualQuantity) || (formdata.status === 2 && formdata.note)) {
       this.setState({ errorMsg: '' });
       const result = await CommonService.updateData('updatestockstatuscontrol', formdata);
       if (result === true) {
          this.onLoadInventory();
          this.setState({ errorMsg: '', modal: false });
          swal('', 'Successfully updated information!', 'success');
       } else {
          this.setState({ modal: false });
          swal('', 'Failed to update information', 'warning');
       }
    } else {
       this.setState({ errorMsg: 'Required fields are empty.' });
    }
 }

  submitReport(e, id) {
    e.preventDefault();
    const { formdata, CommInventory } = this.state;
    formdata.inventory_control_id = id;
    formdata.location_id = this.locationID;
    try {
      if (formdata.actualCount) {
        const response = CommonService.updateData('updatestockactualcount', formdata);
        this.setState({ errorMsg: '' });
        if (response) {
          CommInventory.filter((resp) => {
            if (resp.inventory_control_id === id) {
                resp.stock_balance_actual = formdata.actualCount;
                resp.flag = 1;
            }
            return resp;
          });
          this.setState({ CommInventory, modal: false });
        }
      } else {
        this.setState({ errorMsg: 'Required field is empty!' });
      }
    } catch (err) {
      console.log('Error: ', err.message);
      this.isLoading = false;
    }
 }

  toggleModal(text = '') {
    this.setState(prevState => ({ modal: !prevState.modal }));
    if (text) {
      this.setState({ title: text });
    }
  }

  render() {
    const {
      commissaryData, CommInventory, errorMsg, title, modal, formdata, goTo, goToPage, stockStatus,
    } = this.state;
    const mylocationid = this.locationID;

    if (goTo === true) {
      return <Redirect to={{ pathname: goToPage, state: { prevpage: `/inventory/logistic/dashboard/${formdata.location_id}` } }} />;
    }

    // for search date
    let inventoryDate = new Date();
    let storageDate = new Date();

    if (localStorage.getItem('commissaryInventoryDate') !== null) {
      const storageData = JSON.parse(localStorage.getItem('commissaryInventoryDate'));
      storageDate = new Date(storageData.date);

      let formdate = new Date();
      if (formdata.deliveryDate) {
        formdate = new Date(formdata.deliveryDate);
      }

      inventoryDate = formdata.deliveryDate !== undefined && formdata.deliveryDate !== this.currDate ? formdate : storageDate;
    }

    return (
      <Col md={12}>
        {
          this.executeModal === 'addinventory' ? (
            <AddInventoryModal
              title={`${title} Inventory`}
              icon="fa fa-plus"
              btn="Add Inventory"
              modal={modal}
              toggle={this.toggleModal}
              handleChange={this.handleChange}
              postValue={formdata}
              handleSubmit={this.handleSubmit}
              errorMsg={errorMsg}
              locationID={formdata.location_id}
              locationType="0"
            />
          ) : this.executeModal === 'submitreport' ? (
            <SubmitReportModal
              modal={modal}
              toggle={this.toggleModal}
              handleChange={this.handleChange}
              postValue={formdata}
              errorMsg={errorMsg}
              handleSubmit={this.handleSubmit}
            />
          ) : this.executeModal === 'confirmation' ? (
            <ConfirmStockModal
               modal={modal}
               toggle={this.toggleModal}
               handleChange={this.handleChange}
               postValue={formdata}
               errorMsg={errorMsg}
               handleSubmit={this.handleSubmit}
               stockStatus={stockStatus}
            />
          ) : this.executeModal === 'addtransaction' ? (
            <AddTransactionModal
              title="Stock Withdrawal"
              icon="fa fa-plus"
              btn="Add Transaction"
              modal={modal}
              toggle={this.toggleModal}
              handleChange={this.handleChange}
              handleSubmit={this.handleSubmit}
              postValue={formdata}
              errorMsg={errorMsg}
              locationID={formdata.location_id}
              locationType="0"
            />
          ) : ''
        }
        <Card className="panel panel--primary" id="users_table">
          <CardBody className="panel__body">
            <div className="panel__title bg_blue">
              <h5 className="bold-text">{commissaryData.name}</h5>
              <div className="panel__btns">
                {
                  this.userData && (this.userData.type !== '5') && (
                    <Button onClick={this.addToggle} className="rounded text-white" size="sm" outline>Add Inventory</Button>
                  )
                }

                {
                  this.userData && (this.userData.type !== '6') && (
                    <Button onClick={this.addTransaction} className="rounded text-white" size="sm" outline>Withdraw</Button>
                  )
                }

                {
                  this.userData && (this.userData.type === '1' || this.userData.type === '5' || this.userData.type === '6') && (
                    <Link className="rounded text-white btn btn-sm btn-outline-secondary btn-awesome" to="/inventory/logistic/list">
                      <i className="fa fa-arrow-left" />
                      <span>Back</span>
                    </Link>
                  )
                }
              </div>
            </div>
            <div className="panel__content">
              { this.noreports && (
                <div className="notif_msg full-width clearfix notheadnotif">
                  <Alert color="warning" className="alert--colored">
                    <div className="alert__content">
                      <div>You have an unsubmitted report from {this.reportdate !== '' ? <strong className="text-red">{this.reportdate}</strong> : 'Yesterday' } inventory.</div>
                    </div>
                  </Alert>
                </div>
                )
              }
              <div className="stock-box__container">
                <div className="stock-box outline stock-green">
                  <div className="stock-box__icon"><i className="fa fa-pallet" /></div>
                  <h3 className="stock-box__num">{commissaryData && commissaryData.total_beginning !== '0' ? `${commissaryData.total_beginning} kgs.` : 0}</h3>
                  <h4 className="stock-box__text">Beginning</h4>
                </div>
                <Button className="stock-box outline stock-blue" onClick={this.goTo} data-href={`/stockstracker/${mylocationid}/received/list`}>
                  <div className="stock-box__icon"><i className="fa fa-dolly-flatbed" /></div>
                  <h3 className="stock-box__num">{commissaryData && commissaryData.total_receive !== '0' ? `${commissaryData.total_receive} kgs.` : 0}</h3>
                  <h4 className="stock-box__text">Total Received</h4>
                </Button>
                <Button className="stock-box outline stock-red" onClick={this.goTo} data-href={`/stockstracker/${mylocationid}/stockout/list`}>
                  <div className="stock-box__icon"><i className="fa fa-truck-loading" /></div>
                  <h3 className="stock-box__num">{commissaryData && commissaryData.total_out !== '0' ? `${commissaryData.total_out} kgs.` : 0}</h3>
                  <h4 className="stock-box__text">Total Stock Out</h4>
                </Button>
                <Button className="stock-box outline stock-aqua" onClick={this.goTo} data-href={`/stockstracker/${mylocationid}/stockin/list`}>
                  <div className="stock-box__icon"><i className="fa fa-exchange-alt" /></div>
                  <h3 className="stock-box__num">{commissaryData && commissaryData.transfered_stock_total !== '0' ? `${commissaryData.transfered_stock_total} kgs.` : 0}</h3>
                  <h4 className="stock-box__text">Total Stock In</h4>
                </Button>
              </div>
            </div>
            <div className="panel__content">
              {/* Search Form */}
              <div className="float-right">
                <form className="form form--horizontal" onSubmit={this.searchStocks}>
                    <div className="form__form-group m-b-10">
                      <span className="form__form-group-label text-right">Date:</span>
                      <div className="form__form-group-field">
                          <div className="form__form-group-icon">
                            <CalendarIcon />
                          </div>
                          <div className="date-picker">
                            <DatePicker
                              name="inventoryDate"
                              selected={inventoryDate}
                              popperPlacement="top"
                              onChange={e => this.handleChange(e, 'date')}
                            />
                          </div>
                          <button type="submit" className="form__form-group-button bg-primary"><i className="fa fa-search" /></button>
                      </div>
                    </div>
                </form>
              </div>

              {/* Table */}
              <Table responsive hover striped className="doResTable">
                <thead className="th-vtop">
                  <tr>
                    <th>Product Name</th>
                    <th className="text-center">Beginning</th>
                    <th className="text-center">Received</th>
                    <th className="text-center">Stock In {commissaryData.transfered_stock !== 0 ? <strong className="text-red block">( {commissaryData.transfered_stock} Pending )</strong> : ''}</th>
                    <th className="text-center">Stock Out</th>
                    <th className="text-center">Sold</th>
                    <th className="text-center">Return</th>
                    <th className="text-center">Inventory Date</th>
                    <th className="text-center">New Balance</th>
                    <th className="text-center">Actual Count</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                {
                  CommInventory !== false || CommInventory.length > 0 ? CommInventory.map((item, i) => {
                    const itemId = item.inventory_control_id;
                    const pendingQuantity = (item.stock_receive_pending !== '0' ? item.stock_receive_pending : 0);

                    return (
                      <tr key={itemId} onClick={this.goTo.bind(this)} data-href={`/inventory/logistic/distribution/${item.inventory_control_id}`} className={`text-center ${commissaryData.date > item.date_added ? 'bg-red-l' : ''}`}>
                        <td className="text-left">{item.product_name}</td>
                        <td>{item.stock_beginning !== '0' ? `${item.stock_beginning} kgs.` : 0}</td>
                        <td className="text-center">{item.stock_receive !== '0' ? `${item.stock_receive} kgs.` : 0}</td>
                        <td className="text-center">{item.stock_receive_pending !== '0' ? <strong className="text-red">({item.stock_receive_pending})</strong> : ''} {item.stock_transfer !== '0' ? `${item.stock_transfer} kgs.` : 0}</td>
                        <td>{item.stock_out !== '0' ? `${item.stock_out} kgs.` : 0}</td>
                        <td>{item.stock_sold !== '0' ? `${item.stock_sold} kgs.` : 0}</td>
                        <td>{item.stock_return !== '0' ? `${item.stock_return} kgs.` : 0}</td>
                        <td>{item.date_added}</td>
                        <td>{item.stock_balance !== '0' ? `${item.stock_balance} kgs.` : 0}</td>
                        <td>{item.stock_balance_actual !== '0' ? `${item.stock_balance_actual} kgs.` : 0}</td>
                        <td className="ab">
                          {
                            item.stock_receive_pending !== '0' && item.flag === '0' ? (
                              <span>
                                {/* Approve */}
                                <Button color="success" className="btn-xs" title="Approve" onClick={e => this.confirmStock(e, itemId, 1, pendingQuantity)} id={`approvebtn${i + 1}`} outline><span className="fa fa-check" /></Button>
                                <UncontrolledTooltip placement="bottom" target={`approvebtn${i + 1}`}>Approve</UncontrolledTooltip>
                                {/* Deny */}
                                <Button color="danger" className="btn-xs" title="Deny" onClick={e => this.confirmStock(e, itemId, 2, pendingQuantity)} id={`denybtn${i + 1}`} outline><span className="fa fa-times" /></Button>
                                <UncontrolledTooltip placement="bottom" target={`denybtn${i + 1}`}>Deny</UncontrolledTooltip>
                              </span>
                            ) : ''
                          }

                          {
                            commissaryData.date.toString() >= item.date_added.toString() && item.flag === '0' ? (
                              <span>
                                <Button color="info" id="forwardTP" className="btn-xs" onClick={e => this.reportToggle(e, itemId, item.stock_balance)} outline><span className="fa fa-share" /></Button>
                                <UncontrolledTooltip placement="bottom" target="forwardTP">Submit Report</UncontrolledTooltip>
                              </span>
                            ) : '--'
                          }
                        </td>
                      </tr>
                    );
                  }) : (
                    <tr className="text-center">
                      <td colSpan="11">No data available..</td>
                    </tr>
                  )
                }
                </tbody>
              </Table>
            </div>
            <div className="panel__footer">
              <span><span className="p-x-7 m-r-10 bg-red-l" /> Yesterdays Inventory</span>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withTranslation('common')(CommissaryDashboard);
